package ir.site.zero1plus.components.style

import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.style.CssStyle
import ir.site.zero1plus.theme.TextSecondaryDark
import ir.site.zero1plus.theme.TextSecondaryLight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw

val MyParagraphStyle = CssStyle {
    base {
        Modifier.color(if (colorMode.isDark) TextSecondaryDark else TextSecondaryLight)
            .fontSize(clamp(12.px ,2.5.vw,16.px))
            .textAlign(TextAlign.Justify)
    }
}